import { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import useFeaturePermissions from '../../../hooks/useFeaturePermissions'

export default function ATSOnlyRow() {
   const state = useQuoteContext()
   const { getString } = state
   const { hasPermission } = useFeaturePermissions()
   const canEditATSOnly = hasPermission('ATSOnlyFlag', state.user_role)
   const isDisabled = state.productCoreEECount <= 0 || state.termLength < 12
   const [showAlert, setShowAlert] = useState(false)

   useEffect(() => {
      if (!canEditATSOnly) return
      if (isDisabled && state.isATSOnly) {
         state.setIsATSOnly(false)
      }
   }, [canEditATSOnly, isDisabled, state.isATSOnly, state.setIsATSOnly])

   if (!canEditATSOnly && !state.isATSOnly) return <></>

   const handleChange = () => {
      // If the ATS-Only checkbox is unchecked, show the alert
      if (!state.isATSOnly) {
         setShowAlert(true)
      }
      state.setIsATSOnly((prev: boolean) => !prev)
   }

   return (
      <>
         <Modal show={showAlert} onHide={() => setShowAlert(false)} centered>
            <Modal.Header closeButton>
               <Modal.Title>
                  {getString('product.ATSOnlyRow.Modal.Title')}
               </Modal.Title>
            </Modal.Header>
            <Modal.Body>
               {getString('product.ATSOnlyRow.Modal.Body')}
            </Modal.Body>
            <Modal.Footer>
               <Button variant='primary' onClick={() => setShowAlert(false)}>
                  {getString('product.ATSOnlyRow.Modal.Button')}
               </Button>
            </Modal.Footer>
         </Modal>
         <div className='row'>
            <div className='col-bhr1'>
               {getString('product.ATSOnlyRow.ProductName')}
            </div>
            <div className='col-bhr2'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.isATSOnly}
                  disabled={isDisabled || !canEditATSOnly}
                  onChange={handleChange}
               ></input>
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            {state.differenceQuote ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
                  {process.env.REACT_APP_ENVIRONMENT == 'staging' && (
                     <div className='col'></div>
                  )}
               </>
            ) : (
               <></>
            )}
         </div>
      </>
   )
}
